import { render } from "./Auth.vue?vue&type=template&id=08f277ec&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=08f277ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08f277ec"

export default script